import * as angular from "angular";
import { TeamDataProvider } from "../../../data-provider/team.dp";
import { Team } from "../../../models/team.model";

let InviteTeams = {
    selector: "vcInviteTeams",
    templateUrl:
        "/angular/components/invite/sections/invite-teams.component.html",
    bindings: {
        user: "=",
    },
    controller: class InviteTeamsController {
        // * bindings for typescript compiler *
        public user: any;
        // ************************************

        private readonly $scope: any;
        public teamDataProvider: TeamDataProvider;
        public filter = { search: "" };

        constructor($scope: any, TeamDataProvider: TeamDataProvider) {
            this.$scope = $scope;
            this.teamDataProvider = TeamDataProvider;
            this.teamDataProvider.setFilter(this.filter);

            this.$scope.$watch(
                () => this.filter.search,
                (newValue: string, oldValue: string) => {
                    if (newValue !== oldValue) {
                        this.teamDataProvider.setFilter(this.filter);
                    }
                }
            );
        }

        selectTeam(team: Team): void {
            if (this.isTeamSelected(team)) {
                this.teamDataProvider.spliceTeam(team, this.user.teams);
            } else {
                this.user.teams.push(team);
            }
        }

        isTeamSelected(team: Team): boolean {
            const tids = this.user.teams.map((t) => t.tid);
            return (
                tids.includes(team.tid) || tids.includes(team.tid.toString())
            );
        }
    },
};

angular.module("invite").component(InviteTeams.selector, InviteTeams);
